import React from 'react'
import Logo from '../images/NC_logo_copy.png'
import jnu from '../images/jnu_logo.png'
import IEEE from '../images/IEEE_logo.png'
import SCOPUS from '../images/scopus.png'

function Titlebar() {
  return (
    <div className='container my-3'>
        <div class="row row-cols-1 row-cols-md-4 g-4">
                <div class="col-sm-3 s-12 l-2">
                    <div class="card border-0">
                        <div className="text-center">
                            <img src={Logo} class="card-img-top" alt="..." style={{maxWidth:"60%"}} />
                            <img src={IEEE} class="card-img-top my-5" alt="..." style={{maxWidth:"100%"}} />
                            
                        </div>
                    
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card text-center border-0">
                    <div class="card-body">
                        <h5 className="name"><span className="font-weight-bold">4<sup>th</sup>  INTERNATIONAL CONFERENCE</span></h5>
                            <h6 className="on">On</h6>
                            <h3 className="tech">NETWORKS AND CRYPTOLOGY</h3>
                            {/* <p class="text-success"><a href="https://www.ieee.org/conferences/organizers/conf-app.html?confRecNum=65877" class="link-success link-underline-opacity-25 link-underline-opacity-100-hover" target="_blank"> <strong> IEEE Conference Record Number: 65877</strong> </a> </p> */}
                            <p class="text-success"><a href="https://conferences.ieee.org/conferences_events/conferences/conferencedetails/70801" class="link-success link-underline-opacity-25 link-underline-opacity-100-hover" target='_blank'> <strong> IEEE Conference Record Number: 70801</strong> </a> </p>
                            <p class="text-primary"><strong>Theme: Smart Computing and Intelligent Security</strong> </p>

                            {/* <h6 className="tech"></h6> */}
                            
                            <h6 className="date text-danger">OCTOBER 8<sup>th</sup> - 10<sup>th</sup> , 2026</h6>
                            <h6 className="text-success">(Hybrid Mode)</h6>
                            <h6 className="organized">Organized By</h6>
                            <h5 className="school font-weight-bold">SCHOOL OF COMPUTER AND SYSTEMS SCIENCES</h5>
                        <h6 className="university">JAWAHARLAL NEHRU UNIVERSITY, NEW DELHI, INDIA</h6>
                    </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="card border-0">
                    <img src={jnu} class="rounded mx-auto d-block" alt="..." style={{maxWidth:"65%"}} />
                    <img src={SCOPUS} class="rounded mx-auto d-block my-3" alt="..." style={{maxWidth:"120%"}} />
                    </div>
                </div>
        </div>
    </div>
  )
}

export default Titlebar